const Dollars = (props) => {
    /*
        Formats a number as USD ($) or EUR (€) with 2 decimal places.
        Negative numbers will always be red.
        Default is dollars; pass currency="eur" for Euro.

        Props:
            value -> number to display (null/undefined renders —)
            currency -> 'eur' for Euro (€), otherwise USD ($)
            bold -> bolds text
            cost -> Will show red, even if positive number. Black if 0.
            highlight -> Will highlight in green if positive
    */

    const getClass = (value) => {
        let classes = ''

        if (props.bold) {
            classes = `${classes} font-weight-bold`
        }

        if (value < 0) {
            classes = `${classes} text-danger`
        } else {
            if (props.cost && value !== 0) {
                classes = `${classes} text-danger`
            } else {
                if (props.highlight) {
                    classes = `${classes} text-info`
                }
            }
        }

        return classes
    }

    const value = props.value
    if (value == null || (typeof value === 'number' && isNaN(value))) {
        return <span>—</span>
    }

    const rounded = Math.round(value * 100) / 100
    const currency = String(props.currency || 'USD').toLowerCase()
    const isEur = currency === 'eur'
    const symbol = isEur ? '€' : '$'

    return (
        <span className={getClass(rounded)}>
            {symbol}{Intl.NumberFormat('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(rounded)}
        </span>
    )
}

export default Dollars
